module.exports = __webpack_public_path__ + "img/arrowRight.d07573bf.svg";